import { ref } from "vue";
import { useFetch } from "./fetch";
import { useSessionStorage, StorageSerializers } from "@vueuse/core";

export function useFetchCache({ uri, headers, skipAutoFetch = true }) {
  const cached = useSessionStorage(uri, null, { serializer: StorageSerializers.object });
  const info = useFetch({ uri, headers, skipAutoFetch });
  const cachedData = ref(null);

  if (cached.value && new Date() > new Date(cached.value.exp)) {
    cached.value = null;
  }

  const fetchCachedData = async () => {
    try {
      if (!cached.value) {
        await info.fetchData();
        cachedData.value = info.fetchedData.value;

        let currentDate = new Date();
        let expTime = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);

        cached.value = { exp: expTime, data: info.fetchedData._rawValue };
      } else {
        cachedData.value = cached.value.data;
      }
    } catch (err) {
      cached.value = null;
    }
  };

  !skipAutoFetch && fetchCachedData();

  return { error: info.fetchError, fetchCachedData, cachedData };
}
